import { useCallback, useRef } from 'react';
export var useTabsRefs = function useTabsRefs() {
  // reference to TabList component
  var refList = useRef(null); // map of references to outer button containers

  var refs = useRef({}); // map of references to inner button containers

  var refsInner = useRef({}); // list of tab names

  var tabNames = useRef([]); // callback to reset line position

  var onLineReset = useRef(null);
  var focus = useCallback(function (name) {
    refs.current[name].focus();
  }, []);
  var focusNext = useCallback(function (name) {
    var index = tabNames.current.findIndex(function (n) {
      return n === name;
    });
    var nameNew = index + 1 <= tabNames.current.length - 1 ? tabNames.current[index + 1] : tabNames.current[0];

    if (refs.current[nameNew]) {
      refs.current[nameNew].focus();
    }
  }, []);
  var focusPrevious = useCallback(function (name) {
    var index = tabNames.current.findIndex(function (n) {
      return n === name;
    });
    var nameNew = index - 1 >= 0 ? tabNames.current[index - 1] : tabNames.current[tabNames.current.length - 1];

    if (refs.current[nameNew]) {
      refs.current[nameNew].focus();
    }
  }, []);
  var focusFirst = useCallback(function () {
    var nameNew = tabNames.current[0];

    if (refs.current[nameNew]) {
      refs.current[nameNew].focus();
    }
  }, []);
  var focusLast = useCallback(function () {
    var nameNew = tabNames.current[tabNames.current.length - 1];

    if (refs.current[nameNew]) {
      refs.current[nameNew].focus();
    }
  }, []);
  return {
    refList: refList,
    refs: refs,
    refsInner: refsInner,
    tabNames: tabNames,
    onLineReset: onLineReset,
    focus: focus,
    focusNext: focusNext,
    focusPrevious: focusPrevious,
    focusFirst: focusFirst,
    focusLast: focusLast
  };
};